/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { mediaQuery } from '@datacamp/waffles/helpers';
import { jsx } from '@emotion/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Slides from '../../components/Slides';

import { useSlides } from './hooks/useSlides';

export const ModalSlides: React.FC = () => {
  const { isClosed, setClosed, slides_link, uiTheme } = useSlides();
  const { t } = useTranslation();

  return (
    <>
      <Dialog.Header>{t('ModalSlides.header')}</Dialog.Header>
      <Dialog.Body
        css={{
          height: 400,
          padding: 0,
          [mediaQuery.aboveSmall]: {
            height: 600,
            minWidth: 600,
          },
        }}
      >
        <Slides
          uiThemes={uiTheme}
          isClosed={isClosed}
          slides_link={slides_link}
          setClosed={setClosed}
        />
      </Dialog.Body>
    </>
  );
};

export default ModalSlides;
